import React from 'react';

import { withStyles, Typography } from '@material-ui/core';
import ButtonsForm from 'ui/form/ButtonsForm';
import {
    useArray,
    useBoolean,
    useCounter,
    useOnMount,
    useOnUnmount,
} from 'utils/react';

import { loadNextBackups } from '../Services';
import DownloadTable from './DownloadTable';

const styles = () => ({
    backupDetail: {
        margin: '16px 5px',
        width: '40%',
        marginLeft: '6%',
    },
    downloadList: {
        marginTop: 8,
    },
    showMore: {
        display: 'flex',
        alignItems: 'center',
    },
    showMoreInfo: {
        fontSize: `0.95em`,
        marginLeft: 8,
    },
});

const STEPS = [
    {
        empty: 'Loading...',
        label: '',
        days: 1,
    },
    {
        empty: 'No backups in the last 24 hours.',
        label: 'Showing backups from last 7 days.',
        days: 7,
    },
    {
        empty: 'No backups in the last 7 days.',
        label: 'Showing backups from last 30 days.',
        days: 30,
    },
    {
        empty: 'No backups in the last 30 days.',
        label: 'Showing backups from last 90 days.',
        days: 90,
    },
    {
        empty: 'No backups in the last 90 days.',
    },
];

const toDataTable = rows => {
    const fields = ['created_date', 'device_name', 'device_type', 'uuid'];
    return rows.map(row => fields.map(name => row[name]));
};

export const createDetailRender = (company, downloadable) =>
    withStyles(styles)(({ row, classes }) => {
        const files = useArray();
        const counter = useCounter(0, { upper: STEPS.length - 1 });
        const loading = useBoolean(false);
        const mounted = useBoolean(true);
        const step = STEPS[counter.value];
        const isNotLast = () => counter.value !== STEPS.length - 1;
        const goNext = () => {
            counter.increase();
            loading
                .lock(loadNextBackups(company.id, row.uuid, step.days))
                .then(data => {
                    if (mounted.value && data.length) {
                        files.setValue(toDataTable(data));
                    }
                });
        };
        useOnMount(() => {
            mounted.enable();
            goNext();
        });
        useOnUnmount(() => {
            mounted.disable();
        });
        return (
            <div className={classes.backupDetail}>
                {isNotLast() && (
                    <div className={classes.showMore}>
                        <ButtonsForm.NextButton
                            label="Show more"
                            onClick={goNext}
                            disabled={loading.value}
                        />
                        {!files.isEmpty() && (
                            <Typography
                                component="span"
                                className={classes.showMoreInfo}
                            >
                                {step.label}
                            </Typography>
                        )}
                    </div>
                )}
                <div className={classes.downloadList}>
                    <DownloadTable
                        empty={step.empty}
                        files={files.value}
                        account={row.uuid}
                        company={company.id}
                        downloadable={downloadable}
                    />
                </div>
            </div>
        );
    });
